import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connectHits } from 'react-instantsearch-dom';
import ReactTooltip from 'react-tooltip';
import styled from 'styled-components';

import { mediaQueries } from '@general/breakpoints';
import AnnouncementItem from './AnnouncementItem';

export const AnnouncementsListStyled = styled.div`
    margin: -10px;
    overflow-y: auto;
    padding: 10px;

    @media ${mediaQueries.md} {
        min-height: 528px;
    }
`;

const AnnouncementsList = ({ activeAnnouncement, hits, onClickItem, onLoaded }) => {
    const [firstLoad, setFirstLoad] = useState(true);
    const [lastQueryID, setLastQueryId] = useState(null);

    useEffect(() => {
        if (!firstLoad) {
            return;
        }

        setFirstLoad(false);
        onLoaded();
    }, [firstLoad, hits, onLoaded]);

    useEffect(() => {
        if (hits.length === 0) {
            onClickItem(null);
            return;
        }

        if (hits[0].objectID !== lastQueryID) {
            setLastQueryId(hits[0].objectID);
            onClickItem(hits[0]);
        }
    }, [hits, lastQueryID, onClickItem]);

    return (
        <AnnouncementsListStyled className="fade-in-fast" onScroll={() => ReactTooltip.hide()}>
            {hits.map(hit => (
                <AnnouncementItem
                    key={hit.objectID}
                    announcement={hit}
                    isActive={hit.objectID === activeAnnouncement?.objectID}
                    onClickItem={onClickItem}
                />
            ))}
        </AnnouncementsListStyled>
    );
};

AnnouncementsList.propTypes = {
    activeAnnouncement: PropTypes.shape({
        objectID: PropTypes.string.isRequired,
    }),
    hits: PropTypes.arrayOf(
        PropTypes.shape({
            objectID: PropTypes.string.isRequired,
        })
    ).isRequired,

    onClickItem: PropTypes.func.isRequired,
    onLoaded: PropTypes.func.isRequired,
};

export default connectHits(AnnouncementsList);
